import PageTitle from "./pageTitle";
import { useTranslation } from "next-i18next";
import { useQuery } from "@apollo/client";
import { categoriesGql } from "../../gql/queries";
import { CategoryEntityResponseCollection } from "../../gql-types";
import Skeleton from "react-loading-skeleton";
import { formatCategories } from "helpers";
import { useEffect, useState } from "react";
import Link from "next/link";
import TopStores from "./TopStores";
import SmallCardThumbnailMobile from "components/customImages/SmallCardThumbnailMobile";
import { categoryTranslateKey } from "../../helpers/constants/translate";

const MobileCarouselCategories = () => {
  const { t: translate } = useTranslation("categories_carousel");
  const { t: categoryTranslate } = useTranslation("categories");
  const { loading, data } = useQuery<{
    categories?: CategoryEntityResponseCollection;
  }>(categoriesGql);
  const [categories, setCategories] = useState([]);
  const [previousCarouselIndex, setPreviousCarouselIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState<any>();

  const gotToCarouselItem = (index) => {
    const carousel = document.querySelector(".carousel");
    if (!carousel) {
      return;
    }
    const carouselItemWidth = carousel.querySelector(".carouselItem")?.clientWidth || 0;

    setPreviousCarouselIndex(index);
    setCurrentItem(categories[index]);
    carousel.scrollBy({
      left: (carouselItemWidth + 25) * (index - previousCarouselIndex || index),
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (!loading) {
      setCategories(formatCategories(data?.categories?.data || []));
      setCurrentItem(formatCategories(data?.categories?.data || [])[0]);
      const index = Math.floor(formatCategories(data?.categories?.data || []).length / 2);
      setPreviousCarouselIndex(index);
    }
  }, [loading]);

  useEffect(() => {
    if (previousCarouselIndex) {
      gotToCarouselItem(previousCarouselIndex);
    }
  }, [categories]);

  return (
    <div className="relative" id="carousel-categories">
      <div className="p-4 flex flex-col items-center scroll-mt-16 ">
        <div className="mw-[400px] text-center">
          <PageTitle hasBorder={false} title={translate("top_title_category")} />
          <span>{translate("must_visited_categories")}</span>
        </div>
        <div className="flex flex-col w-full items-center mt-4 pb-8 rounded-xl" dir="ltr">
          <div className="flex gap-x-[25px] overflow-x-auto w-full customCarouselScroll carousel">
            {!loading
              ? Array.isArray(categories) &&
                categories?.map((item: any, index) => (
                  <div
                    key={index}
                    className="m-auto min-w-full bg-backgroundGrey rounded-md mb-[50px] pt-2"
                  >
                    <Link key={index} href={`/categories/${item.slug}`} passHref>
                      <div
                        className="carouselItem hero-card rounded-2xl cursor-pointer relative bg-red-300"
                        style={{
                          margin: "8px",
                          minHeight: 250,
                          minWidth: "-webkit-fill-available",
                        }}
                      >
                        <SmallCardThumbnailMobile imageName={item.image.name} alt={item?.name} />

                        <div className="text-white pt-6 pl-6 text-3xl uppercase absolute top-0">
                          {categoryTranslate(categoryTranslateKey(item.slug))}
                        </div>
                      </div>
                    </Link>
                    <div className="flex flex-col items-center w-[96%] m-auto relative pb-3">
                      <TopStores categoryId={item.id} itemsPerPage={2} />
                    </div>
                  </div>
                ))
              : Array.from(Array(7).keys()).map((item, index) => (
                  <Skeleton
                    key={`__index__carousel__card__${index}`}
                    containerClassName="w-64"
                    className="h-80"
                  />
                ))}
          </div>
        </div>
      </div>
      <div className="bg-blue w-36 h-2.5 absolute right-0 rtl:left-0 rtl:right-auto"></div>
    </div>
  );
};

export default MobileCarouselCategories;
